import {
    activityGroupMarkup,
    activityVisibilityMarkup,
    getgroups,
    getVisibility,
    markupPostFormGroups,
    renderDefaultVisibility,
    setGroupViMarkup,
    setPostVisibility,
    setViMarkup,
    toggleActivityPostFormPopup
} from './ui.js';

//fn to open post visibility popup
function closePostVisibilityPopup(formDom) {
    const visibilityEl = formDom.querySelector(".ac-vi-form-pop-main");
    const postFormEl = formDom.querySelector("#whats-new-form");

    visibilityEl.style.display = "none";
    postFormEl.style.display = "block";
}

//fn to set initial active visibility type in popup
function setInisialPostViTypeInPopup(formDom) {
    const option = formDom.querySelector(".ac-vi-form-options");
    Array.from(option.children).forEach((cur) => cur.classList.remove("ac-vi-form-active"));
    const viType = formDom.querySelector("#mf-activity-accessibility").value;
    const activeEl = option.querySelector(`[data-type="${viType}"]`);

    if (!activeEl) return console.log(new Error("no visibility is active!! Thats weird!"));
    activeEl.classList.add("ac-vi-form-active");
}

//fn to reset group select and visibility type
export function resetGroupAndViType(formDom) {
    //reset group
    const haveGroup = formDom.querySelector("#whats-new-post-in");
    if (!haveGroup) return;
    const groups = haveGroup.children;
    if (groups.length) {
        for (const group of groups) {
            group.removeAttribute("selected");
        }
        groups[0].setAttribute("selected", "selected");
    }
    //reset activity visibility
    formDom.querySelector("#mf-activity-accessibility").value = "public";
    setViMarkup(formDom, "public");
}

//fn to close group popup in activity post form
function closeGroupPopup(formDom) {
    //close group
    const group = formDom.querySelector(".ac-group-main");
    if (group) group.remove();
    //open visibility
    formDom.querySelector(".ac-vi-form-pop-main").style.display = "block";
    //set inisial visibility
    setInisialPostViTypeInPopup(formDom);
}

//fn to get all groups from hidden select el in activity post form
function handleGroupSearchInPopupForm(e, formDom, groups) {
    //get input value
    const search = e.target.value.trim().toLowerCase();
    if (!search) {
        // render all groups
        formDom.querySelector(".ac-group-lists").innerHTML = markupPostFormGroups(groups);
        return;
    }
    //find matches group
    const newGroups = Array.from(groups).filter((cur) => cur.dom.label.trim().toLowerCase().startsWith(search));
    // render new groups
    formDom.querySelector(".ac-group-lists").innerHTML = markupPostFormGroups(newGroups);
}

//fn to handle group select in popup form
function handleGroupSelect(item, formDom) {
    const allGroups = item.parentElement.children;
    Array.from(allGroups).forEach((cur) => cur.classList.remove("active"));
    item.classList.add("active");
}

//fn to handle group select save click in popup form
function handleGroupSelectSaveClick(formDom) {
    //select cur selectd group
    const selectedGroup = formDom.querySelector(".ac-vi-group-item.active");

    const hiddenGroupEl = formDom.querySelector(`#whats-new-post-in option[value="${selectedGroup.dataset.id}"]`);
    if (!hiddenGroupEl) return;
    //remove all other selectd el from hiddenGroupEl
    const hidenEls = formDom.querySelectorAll("#whats-new-post-in option");
    for (const hidenEl of hidenEls) {
        hidenEl.removeAttribute("selected");
    }
    //add new selected el
    hiddenGroupEl.setAttribute("selected", "selected");
    //add markup to post form to indicate group is selected
    setGroupViMarkup(formDom, hiddenGroupEl.innerText);
    //close popup
    closeGroupPopup(formDom);
    closePostVisibilityPopup(formDom);
}

//fn to handle activity post form public btn click
function handleActivityPostFormPublickBtnClick(formDom) {
    const markup = activityVisibilityMarkup();
    const form = formDom.querySelector("#whats-new-form");
    //hide the form
    form.style.display = "none";
    //remove previews markup
    const prePop = formDom.querySelector(".ac-vi-form-pop-main");
    if (prePop) prePop.remove();
    //add new markup
    formDom.insertAdjacentHTML("beforeend", markup);
    // add listener
    addListernerToVisibilityPopup(formDom);
    //set inisial visibility
    setInisialPostViTypeInPopup(formDom);
}

//fn to add listener to visibility popup options
function addListernerToVisibilityPopup(formDom) {
    const option = formDom.querySelector(".ac-vi-form-options");
    const options = option.children;

    for (let i = 0; i < options.length; i++) {
        if (i < 3) {
            const index = i;
            options[i].onclick = (e) => {
                handleActivityVisibilityClick(e, options[index], options, formDom);
            };
        } else {
            const index = i;
            options[i].onclick = (e) => {
                handleActivityVisibilityGroupClick(e, options[index], options, formDom);
            };
        }
    }

    formDom.querySelector(".close-popup").onclick = () => {
        closePostVisibilityPopup(formDom);
        toggleActivityPostFormPopup("close");
    };

    formDom.querySelector(".visibility-back").onclick = () => {
        closePostVisibilityPopup(formDom);
    };
}

//fn to handle activity visibility option click
function handleActivityVisibilityClick(e, clickEl, optionsEl, formDom) {
    //remove other active el
    Array.from(optionsEl).forEach((cur) => cur.classList.remove("ac-vi-form-active"));
    //add active to clicked el
    clickEl.classList.add("ac-vi-form-active");
    //set value
    const viType = clickEl.dataset.type;
    setPostVisibility(formDom, viType);
    //set visibility in post form
    setViMarkup(formDom, viType);
    //close visibility popup
    closePostVisibilityPopup(formDom);
}

//fn to add listener to group popup in activity post form
function addListenerToAcViGroupPopup(formDom) {
    const popup = formDom.querySelector(".ac-group-main");
    if (!popup) return console.log(new Error("group popup is not there."));

    popup.onclick = (e) => {
        if (e.target.matches(".ac-group-back")) {
            closeGroupPopup(formDom);
            return;
        }

        if (e.target.closest(".ac-vi-group-item")) {
            const item = e.target.closest(".ac-vi-group-item");
            handleGroupSelect(item, formDom);
        }

        if (e.target.matches(".ac-group-save")) {
            handleGroupSelectSaveClick(formDom);
        }

        if (e.target.closest(".close-popup")) {
            closeGroupPopup(formDom);
            closePostVisibilityPopup(formDom);
            toggleActivityPostFormPopup("close");
        }
    };

    const groups = getgroups(formDom);
    popup.querySelector(".ac-vi-group-search-input").oninput = (e) => {
        handleGroupSearchInPopupForm(e, formDom, groups);
    };
}

//fn to handle activity visibility group option click
function handleActivityVisibilityGroupClick(e, clickEl, optionsEl, formDom) {
    //remove other active el
    Array.from(optionsEl).forEach((cur) => cur.classList.remove("ac-vi-form-active"));
    //add active to clicked el
    clickEl.classList.add("ac-vi-form-active");
    //hide vi popup
    formDom.querySelector(".ac-vi-form-pop-main").style.display = "none";
    //close prePopup
    const prePop = formDom.querySelector(".ac-group-main");
    if (prePop) prePop.remove();
    //open group popup
    formDom.insertAdjacentHTML("beforeend", activityGroupMarkup(getgroups(formDom)));
    //add necessary event listener
    addListenerToAcViGroupPopup(formDom);
}

//fn to get visibility options from activity post form
function activityPostFormEventHandler(e, formDom) {
    const publicBtnClicked = e.target.closest("#visibility-handler");
    if (publicBtnClicked) {
        handleActivityPostFormPublickBtnClick(formDom);
        return;
    }
    if (e.target.closest(".whats-new-close")) {
        e.preventDefault();
        toggleActivityPostFormPopup("close");
        resetActivityForm();
    }
}

//fn to get visibility from activity post form
export function ActivityPostFormInit() {
    //select activity popup form
    const activityPostFormDom = document.getElementById("bp-nouveau-activity-form");
    const activityPostShowCaseForm = document.querySelector(".ac-post-form-showcase");
    if (!activityPostFormDom) return;

    const visibility = getVisibility(activityPostFormDom);

    renderDefaultVisibility(visibility[0].dom.label, activityPostFormDom);

    activityPostFormDom.addEventListener("click", (e) => {
        activityPostFormEventHandler(e, activityPostFormDom);
    });

    activityPostShowCaseForm.addEventListener("click", () => {
        toggleActivityPostFormPopup("open");
    });

    // showcase form btn click handle
    // make main form btn click map to dummy btn
    // so when form open, state reflect as main form btn are clicked
    const map_dummy_btn_to_main_btn = [
        [".ac-post-form-showcase__format .photo", "#whats-new-attachments .image"],
        [".ac-post-form-showcase__format .photo", "#whats-new-attachments .image"],
        [".ac-post-form-showcase__format .video", "#whats-new-attachments .video"],
        [".ac-post-form-showcase__format .attachment", "#whats-new-attachments .documents"],
        [".ac-post-form-showcase__input-box .emoji", "#whats-new-attachments .emojipicker"],
    ];

    map_dummy_btn_to_main_btn.forEach((btn_map) => {
        let dummy_btn = document.querySelector(btn_map[0]);
        let main_btn = document.querySelector(btn_map[1]);
        if (!dummy_btn || !main_btn) return null;
        /*
         * use setTimeout to push callback fn out of the main theread
         * so its run at the end of everything. This btn parent has event listener.
         * so when click bubble up, that listener run and reset the dom.
         * Thats why push this fn out of the main thread. So it run at the end.
         * after all the dom modification happend by other parent listener
         */
        dummy_btn.onclick = () => setTimeout(() => main_btn.click(), 100);
    });
}

//fn to reset activity post form
export function resetActivityForm() {
    jQuery("#whats-new-form").removeClass("submitting");
    jQuery("#whats-new-textarea").removeClass("show-placeholder");

    jQuery("#whats-new-content").hide(200);
    jQuery("#whats-new-attachments").hide();
    jQuery(".whats-new-header-media-section").show(200);
    jQuery(".whats-new-intro-header").css({
        "font-size": "13px",
        "font-weight": "500",
    });
    jQuery(".whats-new-intro-header").show();
    //removes texts
    jQuery(".advanced-th-bp-activity-form").text("");
    jQuery(".media-uploading").remove();
    jQuery(".url-scrap-view").remove();
    jQuery("#whats-new-post-url-preview").val("");
    jQuery("#whats-new-post-media").val("");
}